<template>
    <picture>
        <source
            v-if="hasWebp && enableSources"
            :srcset="`${image.src}.webp`"
            type="image/webp"
        >

        <source
            :srcset="image.src"
            :type="type"
        >

        <img
            :src="image.src"
            alt=""
            :height="image.height"
            :width="image.width"
            loading="lazy"
            @error="errorHandler"
        >
    </picture>
</template>


<script>
    const allowedTypes = [`image/png`, `image/jpeg`];

    export default {
        props: ['image'],

        data () {
            return {
                enableSources: true
            }
        },

        computed: {
            hasWebp () {
                let square = this.image.width * this.image.height;
                return allowedTypes.includes(this.type) && square < 21120000; //1920 * 11000
            },

            type () {
                if (this.image.type) return this.image.type;
                if(!this.image.src) return null;

                let split = this.image.src.split('.');
                let ext = split[split.length - 1].toLowerCase()
                if (ext == 'jpg') ext = 'jpeg';

                return `image/${ext}`;
            }
        },

        methods: {
            errorHandler (e) {
                this.enableSources = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    img {
        background: #fff;
        cursor:     zoom-in;

        margin-right: auto;
        margin-left:  auto;

        display:   block;
        max-width: 100%;
        height:    auto;

        .image-container.text &,
        .image-container.wide & {
            border-radius: 8px;
        }
    }
</style>
